<template>
  <div
    class="flex items-center py-2 px-3 gap-2 bg-primary rounded-md shadow-xs"
  >
    <div class="flex items-center justify-between grow gap-2">
      <div class="flex items-center gap-3">
        <div class="h-8 w-8 bg-gray-200 animate-pulse rounded-xs"></div>
        <div class="h-4 w-[120px] bg-gray-200 animate-pulse rounded-xs"></div>
      </div>
      <div class="h-4 w-[60px] bg-gray-200 animate-pulse rounded-xs"></div>
    </div>
  </div>
</template>

<script setup></script>
